import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { errMsg, http } from "../lib/api";

export const AuthCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    http.post("/auth/google", { session_id: sid })
      .then((r) => { setUser(r.data); toast.success(`Sveiki, ${r.data.name}!`); nav("/", { replace: true }); })
      .catch((e) => { setUser(false); toast.error(errMsg(e)); nav("/prisijungti", { replace: true }); });
  }, [location.hash, nav, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-[var(--c-orange)]" />
    </div>
  );
};
